import { createAction } from '@reduxjs/toolkit';

export const timerUpdateId = createAction('timer/updateId');
export const timerUpdateUID = createAction('timer/updateUID');
export const timerUpdateSID = createAction('timer/updateSID');
export const timerUpdateIsAdded = createAction('timer/updateIsAdded');
export const timerUpdateIsActive = createAction('timer/updateIsActive');

export const timerStore = createAction('timer/store');
export const timerClear = createAction('timer/clear');

export const timerUpdateRequest = createAction('timer/updateRequest');
export const timerUpdateError = createAction('timer/updateError');
export const timerUpdateStore = createAction('timer/updateStore');

export const timerUpdateTillDate = createAction('timer/updateTillDate');
export const timerUpdateSectionType = createAction('timer/updateSectionType');
export const timerUpdateTimeStamp = createAction('timer/updateTimeStamp');
export const timerUpdatePosition = createAction('timer/updatePosition');

export const timerUpdateLinkId = createAction('timer/updateLinkId');
export const timerUpdateLabel = createAction('timer/updateLabel');
export const timerUpdateTitle = createAction('timer/updateTitle');

export const timerUpdateBackgroundColor = createAction('timer/updateBackgroundColor');
export const timerUpdateTextColor = createAction('timer/updateTextColor');
export const timerUpdateOpacity = createAction('timer/updateOpacity');
export const timerUpdateIcon = createAction('timer/updateIcon');

export const timerUpdateSectionIsBackground = createAction('timer/updateSectionIsBackground');
export const timerUpdateSectionTextColor = createAction('timer/updateSectionTextColor');
export const timerUpdateSectionBackgroundColor = createAction('timer/updateSectionBackgroundColor');
export const timerUpdateSectionOpacity = createAction('timer/updateSectionOpacity');
export const timerUpdateSectionIsFullWidth = createAction('timer/updateSectionIsFullWidth');
export const timerUpdateSectionShadow = createAction('timer/updateSectionShadow');
export const timerUpdateSectionShadowColor = createAction('timer/updateSectionShadowColor');
export const timerUpdateSectionPadding = createAction('timer/updateSectionPadding');
export const timerUpdateSectionMargin = createAction('timer/updateSectionMargin');
export const timerUpdateSectionBackgroundType = createAction('timer/updateSectionBackgroundType');
export const timerUpdateSectionBackgroundImage = createAction('timer/updateSectionBackgroundImage');
export const timerUpdateSectionGradientColor1 = createAction('timer/updateSectionGradientColor1');
export const timerUpdateSectionGradientColor2 = createAction('timer/updateSectionGradientColor2');
export const timerUpdateSectionGradientDirection = createAction('timer/updateSectionGradientDirection');
export const timerUpdateSectionGradientOffset = createAction('timer/updateSectionGradientOffset');
export const timerUpdateSectionBorder = createAction('timer/updateSectionBorder');
export const timerUpdateSectionBorderColor = createAction('timer/updateSectionBorderColor');
export const timerUpdateSectionShadowBorderColor = createAction('timer/updateSectionShadowBorderColor');
export const timerUpdateSectionShape = createAction('timer/updateSectionShape');
